/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        maxWidth: '1016px',
        width: '100%',
        p: {
            base: '0px',
            md: '0 40px'
        }
    },
    variants: {
        form: {
            display: 'flex',
            justifyContent: 'center',
            maxWidth: '522px',
            px: 0
        }
    }
}
